import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = { class: "titlebar-text" }
const _hoisted_6 = { class: "titlebar-actions" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_8 = { class: "titlebar-actions-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "ui-card" }
const _hoisted_12 = { class: "ui-card-body" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-18" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_25 = { class: "ant-row" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_31 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_34 = {
  key: 2,
  class: "ant-row"
}
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_36 = { class: "ant-row" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_combo_tipo_integracao_pagamento = _resolveComponent("combo-tipo-integracao-pagamento")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_combo_aplicacao_acrescimo_desconto = _resolveComponent("combo-aplicacao-acrescimo-desconto")!
  const _component_combo_responsavel_taxa_cartao = _resolveComponent("combo-responsavel-taxa-cartao")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.appBase.titulo), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_10)
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_divider, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Tipo")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.state.formaPagamento.tipo,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.formaPagamento.tipo) = $event)),
                      name: "radioGroup",
                      class: "ui-radio"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, {
                          value: _ctx.ETipoFormaPagamento.Dinheiro
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Dinheiro")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_radio, {
                          value: _ctx.ETipoFormaPagamento.TransferenciaDeposito
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Transferência/Depósito")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_radio, {
                          value: _ctx.ETipoFormaPagamento.PIX
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("PIX")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_radio, {
                          value: _ctx.ETipoFormaPagamento.Boleto
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Boleto")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_radio, {
                          value: _ctx.ETipoFormaPagamento.CartaoCredito
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cartão de Crédito")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _createVNode(_component_a_radio, {
                          value: _ctx.ETipoFormaPagamento.CartaoDebito
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cartão de Débito")
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Nome" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "255",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.formaPagamento.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.formaPagamento.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.state.formaPagamento.status,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.formaPagamento.status) = $event)),
                          "button-style": "solid"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createTextVNode("Inativa")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Ativa")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_a_form_item, { label: "Tipo de Integração" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_tipo_integracao_pagamento, {
                          valor: _ctx.state.formaPagamento.tipoIntegracao,
                          "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.formaPagamento.tipoIntegracao) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, { label: "Ordem de Apresentação - Carrinho/Pedido" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.formaPagamento.ordem) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.formaPagamento.ordem]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.state.formaPagamento.tipoIntegracao !== _ctx.ETipoIntegracaoPagamento.Nenhuma)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_divider, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Informações da Integração")
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_a_form_item, { label: "Ambiente" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_radio_group, {
                                value: _ctx.state.formaPagamento.integracaoEmTestes,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.formaPagamento.integracaoEmTestes) = $event)),
                                "button-style": "solid"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_radio_button, { value: false }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Produção/Oficial")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_radio_button, { value: true }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Testes/SandBox")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_a_form_item, { label: "Token" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.formaPagamento.tokenIntegracao) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.formaPagamento.tokenIntegracao]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_a_form_item, { label: "Código/Identificação" }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.formaPagamento.codigoIntegracao) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.formaPagamento.codigoIntegracao]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Valores")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_a_form_item, { label: "Valor mínimo da Compra" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          monetario: true,
                          valor: _ctx.state.formaPagamento.valorMinimo,
                          "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.formaPagamento.valorMinimo) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_a_form_item, { label: "Aplicar Acréscimo" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_aplicacao_acrescimo_desconto, {
                          valor: _ctx.state.formaPagamento.aplicacaoAcrescimo,
                          "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.formaPagamento.aplicacaoAcrescimo) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_a_form_item, { label: "Valor" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          monetario: (_ctx.state.formaPagamento.aplicacaoAcrescimo === _ctx.EAplicacaoAcrescimoDesconto.Valor),
                          percentual: (_ctx.state.formaPagamento.aplicacaoAcrescimo === _ctx.EAplicacaoAcrescimoDesconto.Percentual),
                          valor: _ctx.state.formaPagamento.valorAcrescimo,
                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.formaPagamento.valorAcrescimo) = $event))
                        }, null, 8, ["monetario", "percentual", "valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_a_form_item, { label: "Aplicar Desconto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_aplicacao_acrescimo_desconto, {
                          valor: _ctx.state.formaPagamento.aplicacaoDesconto,
                          "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.formaPagamento.aplicacaoDesconto) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_a_form_item, { label: "Valor" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          monetario: (_ctx.state.formaPagamento.aplicacaoDesconto === _ctx.EAplicacaoAcrescimoDesconto.Valor),
                          percentual: (_ctx.state.formaPagamento.aplicacaoDesconto === _ctx.EAplicacaoAcrescimoDesconto.Percentual),
                          valor: _ctx.state.formaPagamento.valorDesconto,
                          "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.formaPagamento.valorDesconto) = $event))
                        }, null, 8, ["monetario", "percentual", "valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.state.formaPagamento.tipo === _ctx.ETipoFormaPagamento.CartaoCredito)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_a_form_item, { label: "Quantidade de Parcelas - Cartão de Crédito" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.formaPagamento.cartaoQuantidadeParcelas) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.formaPagamento.cartaoQuantidadeParcelas]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_a_form_item, { label: "Responsável Taxas - Cartão de Crédito" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_responsavel_taxa_cartao, {
                              valor: _ctx.state.formaPagamento.cartaoResponsavelTaxas,
                              "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.formaPagamento.cartaoResponsavelTaxas) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.formaPagamento.tipo === _ctx.ETipoFormaPagamento.Boleto)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_a_form_item, { label: "Dias Vencimento Boleto" }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.formaPagamento.boletoDiasVencimento) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.formaPagamento.boletoDiasVencimento]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Instruções de Pré-Venda")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.formaPagamento.instrucoesPreVenda,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.formaPagamento.instrucoesPreVenda) = $event))
                    }, null, 8, ["value"])
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Instruções de Atraso")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.formaPagamento.instrucoesAtraso,
                      "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.formaPagamento.instrucoesAtraso) = $event))
                    }, null, 8, ["value"])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}